export const API_URL = process.env.REACT_APP_API_URL

export const supportedCurrencies = [
    { code: 'GBP', symbol: '£' },
    { code: 'SAR', symbol: 'SAR' },
    { code: 'USD', symbol: '$' },
    { code: 'EUR', symbol: '€' },
    { code: 'AED', symbol: 'DH' },
    { code: 'SGD', symbol: '$' },
    { code: 'IDR', symbol: 'Rp' },
    { code: 'BHT', symbol: '฿' },
    { code: 'JPY', symbol: '¥' },
    { code: 'CNY', symbol: '㍐' },
    { code: 'KRW', symbol: '₩' },
]

export const getClassNameForField = field => {
    return field.type === 'textarea' ||
        field.type === 'group' ||
        field.name === 'header_image' ||
        field.name === 'image_preview' ||
        field.name === 'description' ||
        field.name === 'small_description' ||
        field.name === 'additional_content' ||
        field.name === 'physical_address'
        ? 'md:col-span-2'
        : ''
}

export const shippingFields = [
    { name: 'first_name', type: 'text', required: true },
    { name: 'last_name', type: 'text', required: true },
    { name: 'street_address', type: 'text', required: true },
    { name: 'city', type: 'text', required: true },
    { name: 'postcode', type: 'text', required: true },
    { name: 'phone', type: 'text', required: true },
    { name: 'email', type: 'text', required: true },
    {
        name: 'contact_method',
        type: 'select',
        options: [{ value: 'email' }, { value: 'sms' }],
        defaultValue: 'email',
    },
    {
        name: 'donation_notes',
        type: 'textarea',
        description: true,
        rows: 3,
    },
    {
        name: 'gift_aid',
        type: 'checkbox',
    },
]

export const volunteerFields = [
    {
        name: 'email',
        inputType: 'email',
        type: 'text',
        required: true,
    },
    {
        name: 'name',
        type: 'text',
        required: true,
    },
    {
        name: 'mobile_number',
        inputType: 'number',
        type: 'text',
        required: false,
    },
    {
        name: 'date_of_birth',
        inputType: 'date',
        type: 'text', // You can use a date picker in the UI even if this is "text"
        required: false,
    },
    {
        name: 'address',
        type: 'textarea',
        required: false,
    },
    {
        name: 'facebook_account',
        type: 'text',
        required: false,
    },
    {
        name: 'twitter_account',
        type: 'text',
        required: false,
    },
    {
        name: 'instagram_account',
        type: 'text',
        required: false,
    },
    {
        name: 'tiktok_account',
        type: 'text',
        required: false,
    },
    // {
    //     name: 'volunteering_type',
    //
    //     type: 'select',
    //     required: true,
    //     options: [
    //         { value: 'remote', label: 'Remote' },
    //         { value: 'onsite', label: 'On-site' },
    //         { value: 'one_time', label: 'One-time Event' },
    //     ],
    // },
    // {
    //     name: 'agree_terms',
    //
    //     type: 'checkbox',
    //     required: true,
    // },
]

export const contactFields = [
    { name: 'first_name', type: 'text', required: true },
    { name: 'last_name', type: 'text', required: true },
    { name: 'email', type: 'text', inputType: 'email', required: true },
    {
        name: 'phone_number',

        type: 'text',
        inputType: 'number',
        required: true,
    },
    { name: 'message', type: 'textarea', required: true },
]

export const platformFields = [
    { name: 'platform_name', type: 'multilang', required: true },
    {
        name: 'platform_description',
        type: 'multilang',
        isTextarea: true,
        required: true,
    },

    { name: 'platform_logo', type: 'upload', required: false },
    { name: 'favicon', type: 'upload', required: false },
    { name: 'navbar_logo', type: 'upload', required: false },
    { name: 'footer_logo', type: 'upload', required: false },

    {
        name: 'phone_number',
        type: 'text',
        required: true,
        inputType: 'text',
    },
    { name: 'email', type: 'text', required: true, inputType: 'email' },
    { name: 'physical_address', type: 'multilang', isTextarea: true, required: true },
    { name: 'google_map', type: 'textarea', required: true },
    { name: 'bank_name', type: 'text', required: true },
    { name: 'account_holder', type: 'text', required: true },
    { name: 'account_number', type: 'text', required: true },
    { name: 'sort_code', type: 'text', required: true },
    { name: 'iban', type: 'text', required: false },
    { name: 'swift_bic', type: 'text', required: false },
    { name: 'currency', type: 'text', required: false },
    { name: 'bank_branch', type: 'text', required: false },
    { name: 'instagram', type: 'text', required: false },
    { name: 'tiktok', type: 'text', required: false },
    { name: 'snapchat', type: 'text', required: false },
    { name: 'facebook', type: 'text', required: false },
    { name: 'youtube', type: 'text', required: false },
    { name: 'x', type: 'text', required: false },
]

export const newsFields = [
    { name: 'title', type: 'multilang', required: true },
    { name: 'subtitle', type: 'multilang' },
    {
        name: 'description',
        type: 'multilang',
        // isTextarea: true,
        isRTF: true,
        required: true,
    },
    {
        name: 'image_preview',
        type: 'upload',
        accept: 'image/jpeg,image/jpg,image/png',
        maxSize: 5120,
    },
    {
        name: 'header_image',
        type: 'upload',
        accept: 'image/jpeg,image/jpg,image/png',
        required: true,
        maxSize: 5120,
    },
    {
        name: 'frequent_options',
        type: 'checkbox-group',
        required: true,
        min: 1,
        options: ['single', 'monthly'],
    },
    {
        name: 'donation_options',
        type: 'group',
        multiple: true,
        required: true,
        min: 1,
        fields: [
            {
                name: 'amount',
                type: 'number',
                inputType: 'number',
                required: true,
            },
            { name: 'label', type: 'multilang' },
        ],
    },
    {
        name: 'impact_sections',
        type: 'group',
        multiple: true,
        fields: [
            {
                name: 'icon',
                type: 'text',
                // required: true
            },
            {
                name: 'title',
                type: 'multilang',
                // required: true
            },
            {
                name: 'description',
                type: 'multilang',
                isTextarea: true,
                // required: true,
            },
        ],
    },
    { name: 'call_to_action', type: 'multilang' },
    { name: 'urgency_message', type: 'multilang' },
    {
        name: 'additional_content',

        type: 'multilang',
        isTextarea: true,
    },
    {
        name: 'show_in_hero_banner',

        type: 'checkbox',
    },
    {
        name: 'is_active',

        type: 'checkbox',
    },
    {
        name: 'custom_amount_enabled',

        type: 'checkbox',
    },
    {
        name: 'goal_enabled',

        type: 'checkbox',
    },
    {
        name: 'goal_amount',

        type: 'text',
        prerequisite: 'goal_enabled',
    },
    {
        name: 'is_quick_donation',
        type: 'checkbox',
    },
]

export const religiousDuesFields = [
    { name: 'title', type: 'multilang', required: true },
    { name: 'subtitle', type: 'multilang' },
    {
        name: 'description',
        type: 'multilang',
        // isTextarea: true,
        isRTF: true,
        required: true,
    },
    { name: 'small_description', type: 'multilang' },
    {
        name: 'image_preview',
        type: 'upload',
        accept: 'image/jpeg,image/jpg,image/png',
        maxSize: 5120,
    },
    {
        name: 'header_image',
        type: 'upload',
        accept: 'image/jpeg,image/jpg,image/png',
        required: true,
        maxSize: 5120,
    },
    { name: 'call_to_action', type: 'multilang' },
    {
        name: 'frequent_options',
        type: 'checkbox-group',
        required: true,
        min: 1,
        options: ['single', 'monthly'],
    },
    {
        name: 'donation_options',
        type: 'group',
        multiple: true,
        required: true,
        min: 1,
        fields: [
            {
                name: 'amount',
                type: 'number',
                inputType: 'number',
                required: true,
            },
            { name: 'label', type: 'multilang' },
        ],
    },
    { name: 'additional_content', type: 'multilang' },
    {
        name: 'show_in_hero_banner',
        type: 'checkbox',
    },
    {
        name: 'is_active',
        type: 'checkbox',
    },
    {
        name: 'custom_amount_enabled',
        type: 'checkbox',
    },
    {
        name: 'is_zakat',
        type: 'checkbox',
    },
    {
        name: 'enable_zakat_calculator',
        type: 'checkbox',
    },
    {
        name: 'is_quick_donation',
        type: 'checkbox',
    },
]

export const projectFields = [
    {
        name: 'project_category_id',
        type: 'select',
        options: [],
        required: true,
    },
    { name: 'title', type: 'multilang', required: true },
    { name: 'subtitle', type: 'multilang' },
    {
        name: 'small_description',
        type: 'multilang',
        maxLength: 500,
    },
    {
        name: 'image_preview',
        type: 'upload',
        accept: 'image/jpeg,image/jpg,image/png',
        maxSize: 5120,
    },
    {
        name: 'header_image',
        type: 'upload',
        accept: 'image/jpeg,image/jpg,image/png',
        required: true,
        maxSize: 5120,
    },
    {
        name: 'call_to_action',
        type: 'multilang',
    },
    {
        name: 'donation_options',
        type: 'group',
        multiple: true,
        required: true,
        min: 1,
        fields: [
            {
                name: 'amount',
                type: 'number',
                inputType: 'number',
                required: true,
            },
            {
                name: 'label',
                type: 'multilang',
            },
        ],
    },
    {
        name: 'custom_amount_enabled',
        type: 'checkbox',
    },
    {
        name: 'frequent_options',
        type: 'checkbox-group',
        required: true,
        min: 1,
        options: ['single', 'monthly'],
    },
    {
        name: 'description',
        type: 'multilang',
        // isTextarea: true,
        isRTF: true,
        required: true,
    },
    {
        name: 'additional_content',
        type: 'multilang',
    },
    {
        name: 'show_in_hero_banner',
        type: 'checkbox',
    },
    {
        name: 'is_active',
        type: 'checkbox',
    },
    {
        name: 'goal_enabled',
        type: 'checkbox',
    },
    {
        name: 'goal_amount',
        type: 'text',
        prerequisite: 'goal_enabled',
    },
    {
        name: 'is_quick_donation',
        type: 'checkbox',
    },
]

export const projectCategoriesFields = [
    { name: 'title', type: 'multilang', required: true },
    { name: 'subtitle', type: 'multilang' },

    { name: 'small_description', type: 'multilang' },
    { name: 'call_to_action', type: 'multilang' },
    {
        name: 'description',
        type: 'multilang',
        // isTextarea: true,
        isRTF: true,
        required: true,
    },
    { name: 'additional_content', type: 'multilang' },
    {
        name: 'header_image',
        type: 'upload',
        accept: 'image/jpeg,image/jpg,image/png',
        required: true,
        maxSize: 5120,
    },
]

export const projectJourneyFields = [
    {
        name: 'project_id',

        type: 'select',
        options: [],
        required: true,
    },
    { name: 'happened_at', type: 'date', inputType: 'date', required: true },
    { name: 'title', type: 'multilang', required: true },
    { name: 'subtitle', type: 'multilang' },
    {
        name: 'description',
        type: 'multilang',
        // isTextarea: true,
        isRTF: true,
    },
    {
        name: 'image',
        type: 'upload',
        accept: 'image/jpeg,image/jpg,image/png',
        required: true,
        maxSize: 5120,
    },
]

export const emailCampaignFields = [
    { name: 'subject', type: 'multilang', required: true },
    { name: 'scheduled_at', type: 'datetime', required: true },
    { name: 'body', type: 'multilang', isTextarea: true, required: true },
]

export const reportFields = [
    { name: 'id', type: 'text' },
    { name: 'cart_token', type: 'text' },
    { name: 'currency', type: 'text' },
    { name: 'total_amount', type: 'text' },
    { name: 'payment_method', type: 'text' },
    { name: 'transaction_ref', type: 'text' },
    { name: 'status', type: 'text' },
    { name: 'paid_at', type: 'text' },
    {
        name: 'created_at',

        type: 'text',
    },
    {
        name: 'updated_at',

        type: 'text',
    },
    {
        name: 'items',

        type: 'group',
        multiple: true,
        fields: [
            { name: 'type', type: 'text' },
            { name: 'title', type: 'text' },
            { name: 'label', type: 'text' },
            { name: 'quantity', type: 'text' },
            { name: 'amount', type: 'text' },
            { name: 'subtotal', type: 'text' },
        ],
    },
    {
        name: 'billing',

        type: 'group',
        multiple: false,
        fields: [
            { name: 'first_name', type: 'text' },
            { name: 'last_name', type: 'text' },
            { name: 'street_address', type: 'text' },
            { name: 'city', type: 'text' },
            { name: 'postcode', type: 'text' },
            { name: 'country', type: 'text' },
            { name: 'phone', type: 'text' },
            { name: 'email', type: 'text' },
            { name: 'contact_method', type: 'text' },
            { name: 'donation_notes', type: 'textarea' },
            { name: 'gift_aid', type: 'checkbox' },
        ],
    },
]

export const paymentLoadFields = [
    { name: 'id', type: 'text' },
    { name: 'donation_id', type: 'text' },
    { name: 'received_at', type: 'text' },
    { name: 'payload_summary', type: 'text' },
    { name: 'signature_header', type: 'text' },
    {
        name: 'donation',

        type: 'group',
        multiple: false,
        fields: [
            { name: 'cart_token', type: 'text' },
            { name: 'currency', type: 'text' },
            { name: 'total_amount', type: 'text' },
            { name: 'payment_method', type: 'text' },
            { name: 'transaction_ref', type: 'text' },
            { name: 'status', type: 'text' },
            { name: 'paid_at', type: 'text' },
            {
                name: 'created_at',
                type: 'text',
            },
            {
                name: 'updated_at',
                type: 'text',
            },
        ],
    },
]

export const donationBillingsField = [
    { name: 'first_name', type: 'text' },
    { name: 'last_name', type: 'text' },
    { name: 'street_address', type: 'text' },
    { name: 'postcode', type: 'text' },
    { name: 'country', type: 'text' },
    { name: 'phone', type: 'text' },
    { name: 'email', type: 'text' },
    { name: 'contact_method', type: 'text' },
    { name: 'donation_notes', type: 'textarea' },
    { name: 'gift_aid', type: 'checkbox' },
    {
        name: 'donation',
        type: 'group',
        multiple: false,
        fields: [
            { name: 'cart_token', type: 'text' },
            { name: 'currency', type: 'text' },
            { name: 'total_amount', type: 'text' },
            { name: 'status', type: 'text' },
            { name: 'paid_at', type: 'text' },
            { name: 'payment_method', type: 'text' },
            { name: 'payment_intent_id', type: 'text' },
            { name: 'subscription_id', type: 'text' },
            { name: 'session_id', type: 'text' },
            { name: 'client_secret', type: 'text' },
            { name: 'transaction_ref', type: 'text' },
            { name: 'client_reference_id', type: 'text' },
            { name: 'payment_customer_id', type: 'text' },
            { name: 'payment_method_id', type: 'text' },
            { name: 'ip_address', type: 'text' },
            { name: 'user_agent', type: 'text' },
            {
                name: 'created_at',

                type: 'text',
            },
            {
                name: 'updated_at',

                type: 'text',
            },
        ],
    },
]
